// extracted by mini-css-extract-plugin
export default {"groupSettings":"GroupSettings_groupSettings__bKVQX","applications":"GroupSettings_applications__99q5w","applicationCard":"GroupSettings_applicationCard__Ei9om"};